import { Injectable } from "@angular/core";
import { ForgotPasswordEndpoint } from "@app/services/authentication/forgotPassword-endpoint.service";
import { resetPassword } from "@app/models/OTPResult";


@Injectable()
export class ForgotPasswordService{

    constructor(private forgotPasswordEndPoint: ForgotPasswordEndpoint){}

    getOTP(reset: resetPassword){
        return this.forgotPasswordEndPoint.getOTP(reset);
    }

    resetPassword(number:string,otp:string){
        return this.forgotPasswordEndPoint.resetPasssword(number,otp);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication/forgotPassword.service.ts